export interface NetContent {
  value: number;
  unit: string;
  count?: number;
}

export function formatNetContent(netContent: NetContent): string {
  const { value, unit, count } = netContent;

  if (count) {
    return `${value} x ${count} ${unit}`;
  }

  return `${value} ${unit}`;
}
